import styled from '@bd/bdui-styles/emotion';
// import ContentBanner from '@bd/bdui-contentbanner';
import ContentBanner from './ContentBanner';
import { grid, typography, colors } from '../styles';

export default styled(ContentBanner)`
  width: 100%;
  .ContentBanner_wrapper {
      width: 100%;
  }
  .ContentBanner_inner {
    width: 100%;
    max-width: 2000px;
    margin: 0 auto;
    padding: 15px;
  }
  .ContentBanner_result {
    ${grid.makeRow()}
    margin-bottom: 60px;
  }
  .ContentBanner_resultMedia {
    ${grid.makeCol(12)}
    margin: 0 auto;
    padding: 0;
    @media (min-width: 992px) {
      ${grid.makeCol(6)}
      min-height: 600px;
      padding: 0;
    }
    div {
      background-size: cover;
      background-position: center center;
      height: 100%;
      min-height: 300px;
    }
  }
  .ContentBanner_resultContent {
    ${grid.makeCol(12)}
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px;
    background-color: ${colors.neutral};
    @media (min-width: 992px) {
      ${grid.makeCol(6)}
      padding: 60px;
      padding-right: 60px;
      padding-left: 60px;
    }
  }
  .ContentBanner_title {
    font-weight: bold;
    font-size: 28px;
    font-family: ${typography.Serif};
    color: ${colors.color1};
  }
  .ContentBanner_preTitle {
    font-weight: normal;
    display: block;
    font-size: 16px;
  }
  .ContentBanner_body p {
    line-height: 2;
    font-weight: 300;
  }
  ${props => (!props.alternating ? '' : `
    &:nth-child(even) {
      .ContentBanner_result {
        flex-direction: row-reverse;
      }
    }
  `)}
`;



// WEBPACK FOOTER //
// ./src/components/PageSectionContent.js